import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CurrencyAndLanguageModule } from '../components/currency/currency-and-language.module';
import { ProductCoverModule } from '../components/product-cover/product-cover.module';
import { VgOffCanvasModule } from '../components/vg-off-canvas/vg-off-canvas.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LoginButtonsComponent } from './header/login-buttons/login-buttons.component';
import { CartComponent } from './header/cart/cart.component';
import { PipeModule } from '../pipes/pipes.module';
import { VlBadgeModule, VlButtonModule, VlIconModule, VlInputModule, VlSpinnerModule } from 'vl-tailwind-layout';
import { SearchProductComponent } from './header/search-product/search-product.component';
import { VgImageModule } from '../components/vg-image/vg-image.module';
import { SkeletonModule } from '../components/skeleton/skeleton.module';

let LAYOUT_COMPONENTS = [
    HeaderComponent,
    LoginButtonsComponent,
    FooterComponent,
    CartComponent,
    SearchProductComponent
]

const VL_TAILWIND_LAYOUT = [
    VlButtonModule,
    VlIconModule,
    VlSpinnerModule,
    VlBadgeModule
]

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ProductCoverModule,
        CurrencyAndLanguageModule,
        VgOffCanvasModule,
        PipeModule,
        VlButtonModule,
        VlIconModule,
        VlInputModule,
        SkeletonModule,
        VgImageModule,
        ...VL_TAILWIND_LAYOUT,
    ],
    declarations: [
        ...LAYOUT_COMPONENTS,
    ],
    exports: [
        ...LAYOUT_COMPONENTS,
    ]
})
export class LayoutModule { }
